/** Talent search, profile, filters. Catalog labels come from catalogs/*. */
const dictionary = {
  "en": {
    "tags": {
      "employee": "Employee",
      "pendingConsent": "Pending consent",
      "pendingInvite": "Pending consent",
      "teamInviteSent": "Team invite sent",
      "candidate": "Candidate"
    },
    "actions": {
      "hire": "Hire",
      "inviteToPool": "Invite To Pool",
      "removeFromPool": "Remove from pool",
      "moveToAnotherPool": "Move To Another Pool",
      "deleteFromPool": "Delete From Pool",
      "moveToAnotherPoolLabel": "Move to Another Pool",
      "deleteFromThePool": "Delete From the Pool",
      "copyAllEmail": "Copy all email",
      "deleteFromPoolMenu": "Delete from pool",
      "moveToAnotherPoolMenu": "Move to another pool"
    },
    "sections": {
      "motivations": "Motivational factors",
      "workStyles": "Work style preferences",
      "reasoningAndSkills": "Reasoning and Skills",
      "highestCompatibility": "Highest compatibility",
      "assessmentReports": "Assessment Reports",
      "targetPositionCompetencies": "Target Position Competencies"
    },
    "scale": {
      "ifAboveAverage": "If above Average",
      "ifBelowAverage": "If below Average",
      "whenAboveAverage": "When {label} is above Average",
      "whenBelowAverage": "If {label} is below Average"
    },
    "charts": {
      "teamStrengths": "Team Strengths",
      "teamStrengthsInfo": "Team Strengths Info",
      "salesStrengths": "Sales Strengths",
      "salesStrengthsInfo": "Sales Strengths Info",
      "adeptWorkStyles": "Adept Work Styles",
      "adeptWorkStylesInfo": "Adept Work Styles Info",
      "competence": "Competence",
      "attitude": "Attitude"
    },
    "help": {
      "workStyles": "The higher the score on the competence, the more a person likes and has potential to do the activity compared to other activities. The lower the score on the competence, the less a person likes to do the activity compared to other activities.",
      "motivations": "The higher the result in the area, the more important the Value & Motivation factor is to the person in relation to other factors. Top of the list motivates the person a lot. Low score does not necessarily mean that the factor does not matter at all",
      "reasoningAndSkills": "The higher the score on the skill, the more a person likes and has potential to do it compared to other skills. The lower the score on the skill, the less a person likes to do it compared to other skills."
    },
    "waitingInvite": "Waiting for candidate to accept invite",
    "deleteCandidate": "Delete Candidate",
    "deleteCandidateBody": "This action canot be undone. Please go to the specific pool page and remove the candidate from there",
    "goToPool": "Go to Pool",
    "goToPoolNamed": "Go to {title}",
    "moveSelected": "Move Selected Candidates to Another Pool",
    "moveNamedPrefix": "Move",
    "moveNamedSuffix": "to Another Pool",
    "removeFromOrigin": "Remove from Origin Pool",
    "actionsForTalent": "Actions For Talent",
    "pools": "Pools:",
    "teams": "Teams:",
    "addCandidateToTeam": "Add candidate to the team",
    "selectTeam": "Select team",
    "inviteCandidateForPosition": "Invite candidate for position",
    "jobPositions": "Job Positions",
    "selectJobPosition": "Select job position",
    "matchPercent": "{percentage}% match",
    "percentMatch": "{percentage}% Match",
    "downloadableReportAlt": "Downloadable Report",
    "sendReminder": "Send assessments reminder",
    "status": "Status",
    "filters": {
      "addFilter": "Add Filter",
      "savedFilters": "Saved Filters",
      "saveFilter": "Save Filter",
      "saveFilterPrompt": "Please enter name of this filter",
      "filterName": "Filter name",
      "filterNameExample": "e.g. Company shared values",
      "type": "Type",
      "selectType": "Select Type",
      "selectTeamsList": "Select Teams List",
      "selectJobPositionList": "Select Job Position List"
    },
    "toasts": {
      "moveFailed": "Failed to move candidate to team {name}. Please try again.",
      "reminderSent": "Reminder email sent",
      "reminderError": "Unable to reminder email",
      "generatingReport": "Generating report...",
      "reportGenerated": "Report generated successfully",
      "reportFailedRetry": "Failed to generate report. Please try again. Or contact our support team.",
      "reportFailed": "Failed to generate report"
    }
  },
  "de": {
    "tags": {
      "employee": "Teammitglied",
      "pendingConsent": "Einwilligung ausstehend",
      "pendingInvite": "Einwilligung ausstehend",
      "teamInviteSent": "Teameinladung gesendet",
      "candidate": "Bewerbende"
    },
    "actions": {
      "hire": "Einstellen",
      "inviteToPool": "In Pool einladen",
      "removeFromPool": "Aus Pool entfernen",
      "moveToAnotherPool": "In anderen Pool verschieben",
      "deleteFromPool": "Aus Pool löschen",
      "moveToAnotherPoolLabel": "In anderen Pool verschieben",
      "deleteFromThePool": "Aus dem Pool löschen",
      "copyAllEmail": "Alle E-Mails kopieren",
      "deleteFromPoolMenu": "Aus Pool löschen",
      "moveToAnotherPoolMenu": "In anderen Pool verschieben"
    },
    "sections": {
      "motivations": "Motivationsfaktoren",
      "workStyles": "Arbeitsstilpräferenzen",
      "reasoningAndSkills": "Kognitive Fähigkeiten",
      "highestCompatibility": "Höchste Passung",
      "assessmentReports": "Assessment-Berichte",
      "targetPositionCompetencies": "Kompetenzen der Zielposition"
    },
    "scale": {
      "ifAboveAverage": "Wenn überdurchschnittlich",
      "ifBelowAverage": "Wenn unterdurchschnittlich",
      "whenAboveAverage": "Wenn {label} überdurchschnittlich ist",
      "whenBelowAverage": "Wenn {label} unterdurchschnittlich ist"
    },
    "charts": {
      "teamStrengths": "Stärken im Team",
      "teamStrengthsInfo": "Stärken im Team-Info",
      "salesStrengths": "Stärken im Vertrieb",
      "salesStrengthsInfo": "Stärken im Vertrieb-Info",
      "adeptWorkStyles": "Adept-Arbeitsstile",
      "adeptWorkStylesInfo": "Adept-Arbeitsstile-Info",
      "competence": "Kompetenz",
      "attitude": "Haltung"
    },
    "help": {
      "workStyles": "Je höher der Wert bei der Kompetenz, desto mehr mag und kann die Person diese Tätigkeit im Vergleich zu anderen Tätigkeiten. Je niedriger der Wert, desto weniger mag die Person diese Tätigkeit im Vergleich zu anderen.",
      "motivations": "Je höher das Ergebnis im Bereich, desto wichtiger ist der Werte- und Motivationsfaktor für die Person im Verhältnis zu anderen Faktoren. Die Punkte oben auf der Liste motivieren stark. Ein niedriger Wert bedeutet nicht unbedingt, dass der Faktor gar keine Rolle spielt",
      "reasoningAndSkills": "Je höher der Wert bei der Fähigkeit, desto mehr mag und kann die Person sie im Vergleich zu anderen Fähigkeiten. Je niedriger der Wert, desto weniger mag die Person sie im Vergleich zu anderen Fähigkeiten."
    },
    "waitingInvite": "Einladung wurde versendet - Annahme steht noch aus",
    "deleteCandidate": "Bewerbenden löschen",
    "deleteCandidateBody": "Diese Aktion kann nicht rückgängig gemacht werden. Bitte öffnen Sie die entsprechende Pool-Seite, um die Person dort zu entfernen.",
    "goToPool": "Zum Pool",
    "goToPoolNamed": "Zu {title}",
    "moveSelected": "Ausgewählte Bewerbende in einen anderen Pool verschieben",
    "moveNamedPrefix": "Verschieben",
    "moveNamedSuffix": "in einen anderen Pool",
    "removeFromOrigin": "Aus dem Ursprungspool entfernen",
    "actionsForTalent": "Aktionen für Talent",
    "pools": "Pools:",
    "teams": "Teams:",
    "addCandidateToTeam": "Bewerbende zum Team hinzufügen",
    "selectTeam": "Team auswählen",
    "inviteCandidateForPosition": "Bewerbende für Position einladen",
    "jobPositions": "Positionen",
    "selectJobPosition": "Position auswählen",
    "matchPercent": "{percentage}% Passung",
    "percentMatch": "{percentage}% Passung",
    "downloadableReportAlt": "Bericht zum Herunterladen",
    "sendReminder": "Erinnerung zu Assessments senden",
    "status": "Status",
    "filters": {
      "addFilter": "Filter hinzufügen",
      "savedFilters": "Gespeicherte Filter",
      "saveFilter": "Filter speichern",
      "saveFilterPrompt": "Bitte geben Sie den Namen dieses Filters ein",
      "filterName": "Filtername",
      "filterNameExample": "z. B. Gemeinsame Unternehmenswerte",
      "type": "Typ",
      "selectType": "Typ auswählen",
      "selectTeamsList": "Teamliste auswählen",
      "selectJobPositionList": "Positionsliste auswählen"
    },
    "toasts": {
      "moveFailed": "Diese Person konnte nicht ins Team {name} verschoben werden. Bitte versuchen Sie es erneut.",
      "reminderSent": "Erinnerungs-E-Mail gesendet",
      "reminderError": "Erinnerungs-E-Mail konnte nicht gesendet werden",
      "generatingReport": "Bericht wird erstellt...",
      "reportGenerated": "Bericht erfolgreich erstellt",
      "reportFailedRetry": "Bericht konnte nicht erstellt werden. Bitte versuchen Sie es erneut oder kontaktieren Sie unser Support-Team.",
      "reportFailed": "Bericht konnte nicht erstellt werden"
    }
  },
  "fi": {
    "tags": {
      "employee": "Työntekijä",
      "pendingConsent": "Odottaa suostumusta",
      "pendingInvite": "Odottaa suostumusta",
      "teamInviteSent": "Tiimikutsu lähetetty",
      "candidate": "ehdokas"
    },
    "actions": {
      "hire": "Palkkaa",
      "inviteToPool": "Kutsu pooliin",
      "removeFromPool": "Poista poolista",
      "moveToAnotherPool": "Siirrä toiseen pooliin",
      "deleteFromPool": "Poista poolista",
      "moveToAnotherPoolLabel": "Siirrä toiseen pooliin",
      "deleteFromThePool": "Poista poolista",
      "copyAllEmail": "Kopioi kaikki sähköpostit",
      "deleteFromPoolMenu": "Poista poolista",
      "moveToAnotherPoolMenu": "Siirrä toiseen pooliin"
    },
    "sections": {
      "motivations": "Motivaatiotekijät",
      "workStyles": "Työskentelytyylit",
      "reasoningAndSkills": "Päättely ja taidot",
      "highestCompatibility": "Korkein yhteensopivuus",
      "assessmentReports": "Arviointiraportit",
      "targetPositionCompetencies": "Kohdetehtävän osaamisalueet"
    },
    "scale": {
      "ifAboveAverage": "Jos keskiarvon yläpuolella",
      "ifBelowAverage": "Jos keskiarvon alapuolella",
      "whenAboveAverage": "Kun {label} on keskiarvon yläpuolella",
      "whenBelowAverage": "Jos {label} on alle keskiarvon"
    },
    "charts": {
      "teamStrengths": "Tiimivahvuudet",
      "teamStrengthsInfo": "Tietoa tiimin vahvuuksista",
      "salesStrengths": "Myyntivahvuudet",
      "salesStrengthsInfo": "Myynnin vahvuudet tiedot",
      "adeptWorkStyles": "Adept-työtyylit",
      "adeptWorkStylesInfo": "Tietoa Adept-työtyyleistä",
      "competence": "Pätevyys",
      "attitude": "Asenne"
    },
    "help": {
      "workStyles": "Mitä korkeampi osaamisalueen pistemäärä, sitä enemmän henkilö pitää kyseisestä toiminnasta ja sitä enemmän hänellä on siihen potentiaalia muihin toimintoihin verrattuna. Mitä matalampi osaamisalueen pistemäärä, sitä vähemmän henkilö pitää kyseisestä toiminnasta muihin toimintoihin verrattuna.",
      "motivations": "Mitä korkeampi tulos alueella, sitä tärkeämpi arvo- tai motivaatiotekijä on henkilölle muihin tekijöihin verrattuna. Listan kärjessä olevat tekijät motivoivat henkilöä paljon. Matala pistemäärä ei välttämättä tarkoita, ettei tekijällä olisi lainkaan merkitystä.",
      "reasoningAndSkills": "Mitä korkeampi taidon pistemäärä, sitä enemmän henkilö pitää sen tekemisestä ja sitä enemmän hänellä on siihen potentiaalia muihin taitoihin verrattuna. Mitä matalampi taidon pistemäärä, sitä vähemmän henkilö pitää sen tekemisestä muihin taitoihin verrattuna."
    },
    "waitingInvite": "Odotetaan ehdokkaan hyväksyvän kutsun",
    "deleteCandidate": "Poista ehdokas",
    "deleteCandidateBody": "Tätä toimintoa ei voi kumota. Mene kyseiselle poolisivulle ja poista ehdokas sieltä",
    "goToPool": "Siirry pooliin",
    "goToPoolNamed": "Siirry kohteeseen {title}",
    "moveSelected": "Siirrä valitut ehdokkaat toiseen pooliin",
    "moveNamedPrefix": "Siirrä",
    "moveNamedSuffix": "toiseen pooliin",
    "removeFromOrigin": "Poista alkuperäisestä poolista",
    "actionsForTalent": "Toiminnot talentille",
    "pools": "Poolit:",
    "teams": "Tiimit:",
    "addCandidateToTeam": "Lisää ehdokas tiimiin",
    "selectTeam": "Valitse tiimi",
    "inviteCandidateForPosition": "Kutsu ehdokas virkaan",
    "jobPositions": "Työpaikat",
    "selectJobPosition": "Valitse työpaikka",
    "matchPercent": "{percentage}% yhteensopivuus",
    "percentMatch": "{percentage}% yhteensopivuus",
    "downloadableReportAlt": "Ladattava raportti",
    "sendReminder": "Lähetä arviointimuistutus",
    "status": "Tila",
    "filters": {
      "addFilter": "Lisää suodatin",
      "savedFilters": "Tallennetut suodattimet",
      "saveFilter": "Tallenna suodatin",
      "saveFilterPrompt": "Anna tämän suodattimen nimi",
      "filterName": "Suodattimen nimi",
      "filterNameExample": "esim. Yrityksen yhteiset arvot",
      "type": "Tyyppi",
      "selectType": "Valitse Tyyppi",
      "selectTeamsList": "Valitse tiimilista",
      "selectJobPositionList": "Valitse Työpaikkaluettelo"
    },
    "toasts": {
      "moveFailed": "Ehdokkaan siirtäminen tiimiin {name} epäonnistui. Yritä uudelleen.",
      "reminderSent": "Muistutussähköposti lähetetty",
      "reminderError": "Muistutussähköpostia ei voi lähettää",
      "generatingReport": "Raporttia luodaan...",
      "reportGenerated": "Raportti luotu onnistuneesti",
      "reportFailedRetry": "Raportin luominen epäonnistui. Yritä uudelleen. Tai ota yhteyttä tukitiimiimme.",
      "reportFailed": "Raportin luominen epäonnistui"
    }
  }
};

export default dictionary;
